<div class="product-depots-picker" [class.is-loading]="isLoading">
  <loading-spinner
    [isLoading]="isLoading"
    [spinnerOverlayAddedClass]="'product-depots-picker-spinner-overlay'"
  ></loading-spinner>
  @if (!isLoading && groups.length === 0) {
    <div class="p-3">{{ 'no.records' | translate }}</div>
  }
  <div class="depot-groups">
    @for (group of groups; track group.depot?.id) {
      <div class="depot-group">
        <div class="depot-group-label">
          <span class="depot-group-icon"><i class="far fa-warehouse-alt"></i></span>
          <span class="depot-group-name">{{ group.depot?.name }}</span>
        </div>
        <div class="depot-group-box">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>{{ 'supplier' | translate }}</th>
                <th>{{ 'product.batch' | translate }}</th>
                <th>{{ 'product.expirationDate' | translate }}</th>
                <th>{{ 'position' | translate }}</th>
                <th class="col-availability text-center">{{ 'products.availability' | translate }}</th>
                <th class="col-tags-spacer">&nbsp;</th>
                <th class="col-qty text-center">{{ 'bill.qty' | translate }}</th>
                <th class="col-spacer">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              @for (row of group.rows; track row.id) {
                @if (showEmptyPositions() || !(row.quantityStock == 0 && row.quantityReservation == 0)) {
                  <tr>
                    <td>{{ row.supplier?.name }}</td>
                    <td>{{ row.batch }}</td>
                    <td>
                      {{ row.expirationDate ? (row.expirationDate | fmtDate: 'dd.MM.yyyy') : '' }}
                    </td>
                    <td>{{ row.position }}</td>
                    <td class="col-availability text-center text-nowrap">
                      <span class="quantityStock badge badge-pill">{{ row.quantityStock }}</span>
                      <span class="quantityReservation badge badge-pill">{{ row.quantityReservation }}</span>
                      <span class="quantityAvailable badge badge-pill radius">{{ row.quantityAvailable }}</span>
                    </td>
                    <td class="col-tags-spacer"></td>
                    <td class="col-qty text-center">
                      <div class="flex-direction-column-gap-5 align-items-center">
                        <form-row-number-with-controls
                          [label]="null"
                          [model]="row.orderQuantityTmp || 0"
                          (modelChange)="setQty(row, $event)"
                          [minWidthPx]="120"
                          [maxWidthPx]="120"
                          [noMarginBottom]="true"
                          class="d-flex justify-content-center"
                          [dataCyAttribute]="'product-depot-qty'"
                        ></form-row-number-with-controls>
                        @if (alreadyAddedQuantity(row) > 0) {
                          <div class="already-added-hint">
                            {{
                              'product-depots-picker.already-added' | translate: { quantity: alreadyAddedQuantity(row) }
                            }}
                          </div>
                        }
                      </div>
                    </td>
                    <td class="col-spacer">
                      <btn
                        [label]="'add'"
                        [title]="'add' | translate"
                        [icon]="'far-plus'"
                        [classes]="['btn-second', 'btn-sm']"
                        (onEvent)="addRow(row)"
                        [dataCyAttribute]="'product-depot-add'"
                      ></btn>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
</div>
